// @ts-nocheck
import React from "react";
import { ReactComponent as FilterLinesIcon } from "../../../assets/icons/filter-lines.svg";
import { ReactComponent as ClockIcon } from "../../../assets/icons/clock-01.svg";
import { ReactComponent as DatasetsIcon } from "../../../assets/icons/layers-icon.svg";
import Select from "../../ReusableComponents/Select";

// The compact control cluster below sm — variation, time range and datasets as icon-only toolbar pills. Shared with the processed-model results modal and the graph previewer, so the default button class is the pill: a caller that passes its own still overrides it.

// The variation picker: a toolbar pill on the shared Select, so it gets the same list on desktop and the centered card on a phone
export const VariationMenu = ({
  buttonClassName,
  showLabel,
  labelFallback = "Variations",
  variationOptions = [],
  selectedVariationKey,
  onSelectVariation,
}) => (
  <Select
    aria-label="Select variation"
    className={buttonClassName}
    trigger={
      <>
        <FilterLinesIcon className="h-3.5 w-3.5 shrink-0 [&_path]:stroke-current" />
        {showLabel && (
          <span className="hidden max-w-[8rem] truncate sm:inline">
            {variationOptions.find((opt) => opt.key === selectedVariationKey)?.label || labelFallback}
          </span>
        )}
      </>
    }
    value={selectedVariationKey ?? ""}
    // Hand back the option's own key, not the native select's string
    onChange={(e) => onSelectVariation(variationOptions.find((opt) => String(opt.key) === e.target.value)?.key)}
    options={variationOptions.map((opt) => ({ value: opt.key, label: opt.label }))}
  />
);

const GraphMobileControls = ({
  className,
  variationOptions = [],
  selectedVariationKey,
  onSelectVariation,
  variationButtonClassName,
  onOpenTimeRange,
  onOpenDataset,
  buttonClassName,
  disabled = false,
  variationTour,
  timeRangeTour,
  datasetsTour,
}) => {
  const btnClass = buttonClassName || "eai-btn-toolbar-icon";
  return (
    <div className={className}>
      {variationOptions.length > 0 && (
        <div data-tour={variationTour} className="flex items-center">
          <VariationMenu
            buttonClassName={variationButtonClassName || btnClass}
            showLabel={false}
            variationOptions={variationOptions}
            selectedVariationKey={selectedVariationKey}
            onSelectVariation={onSelectVariation}
          />
        </div>
      )}
      {!disabled && <button
        type="button"
        onClick={onOpenTimeRange}
        data-tour={timeRangeTour}
        aria-label="Select time range"
        className={btnClass}
      >
        <ClockIcon className="h-3.5 w-3.5 shrink-0 [&_path]:stroke-current" />
      </button>}
      {!disabled && <button
        type="button"
        onClick={onOpenDataset}
        data-tour={datasetsTour}
        aria-label="Toggle dataset visibility"
        className={btnClass}
      >
        <DatasetsIcon className="h-3.5 w-3.5 shrink-0 [&_path]:stroke-current" />
      </button>}
    </div>
  );
};

export default GraphMobileControls;
